var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.is,_vm._g(_vm._b({tag:"component",class:[
    'btn',
    {
      'btn-primary': _vm.theme === 'primary',
      'btn-secondary': _vm.theme === 'secondary',
      'btn-danger': _vm.theme === 'danger',
      'btn-success': _vm.theme === 'success',
      [_vm.$style.btnLoading]: _vm.isLoading,
    }
  ],attrs:{"to":_vm.to || undefined,"href":_vm.href || _vm.to || undefined,"type":(_vm.to || _vm.href) ? undefined : 'button'}},'component',_vm.$attrs,false),_vm.$listeners),[_c('span',{class:_vm.$style.content},[_vm._t("default")],2),_vm._v(" "),(_vm.isLoading)?_c('app-spinner',{class:_vm.$style.spinner}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }